const getQueryParam = (param) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
};

const getAuthenticateUrl = (API_HOST, code, type) => {
  console.log("getAuthenticateUrl", type, typeof type);
  if (type === "1") return `${API_HOST}/api/bot/authenticate/${code}`;
  return `${API_HOST}/api/authenticate/${code}`;
};

const getFeedbackSubmitUrl = (API_HOST, token, type) => {
  if (type === "1") return `${API_HOST}/api/bot/submit-survey/${token}`;
  return `${API_HOST}/api/submit-survey/${token}`;
};

export { getQueryParam, getAuthenticateUrl, getFeedbackSubmitUrl };
